<sgt-multi-select
  [options]="tags"
  [settings]="settings"
  [variante]="variante"
  [icon]="icon"
  [(ngModel)]="value"
  (ngModelChange)="onSelectionChange()"
  (isFirstOpened)="firstOpened($event)"
  (search)="onSearch()"
>
</sgt-multi-select>
